<template>
  <div class="postcode-check block">
    <div class="postcode-check__icon"></div>

    <div class="postcode-check__content">
      <h2>Postcode check</h2>
      <div>Bekijk welke producten voor u beschikbaar zijn</div>
    </div>

    <form class="postcode-check__form" @submit.prevent="check">
      <div class="form-group postcode-check__postcode">
        <label>Postcode</label>
        <input type="text" v-model="postcode" required />
      </div>

      <div class="form-group postcode-check__number">
        <label>Huisnr.</label>
        <input type="text" v-model="number" required />
      </div>

      <div class="form-group postcode-check__suffix">
        <label>Toev.</label>
        <input type="text" v-model="suffix" />
      </div>

      <div v-if="State.isInternal == 1" class="form-group postcode-check__suffix">
        <label>Type</label>
        <input list="saletypes" id="type-choice" name="type" v-model="type" />
        <datalist id="saletypes">
          <option v-for="option in types" :value="option">{{option}}</option>
        </datalist>
      </div>

      <div v-if="State.isInternal == 1" class="form-group postcode-check__suffix">
        <label>Offerte</label>
        <input type="checkbox" v-model="quote"/>
      </div>

      <div class="form-group">
        <label>&nbsp;</label>
        <button type="submit" class="btn-2">Check</button>
      </div>
    </form>
  </div>
</template>

<script>
const ls = window.localStorage
import State from '../state'
export default {
  data () {
    return {
      postcode: ls.getItem('plinq.postcode') || '',
      number: ls.getItem('plinq.number') || '',
      suffix: ls.getItem('plinq.suffix') || '',
      State,
      type:  ls.getItem('plinq.type') || '',
      types: [
          'thuis',
          'zakelijk',
          'wholesale'
      ],
      quote: ls.getItem('plinq.quote') || '',

    }
  },
  methods: {
    check () {
      this.save()
      this.$emit('check', {
        postcode: this.postcode,
        houseNumber: this.number,
        houseNumberExt: this.suffix,
        type: this.type,
        quote: this.quote,

      })
    },
    save () {
      ls.setItem('plinq.postcode', this.postcode)
      ls.setItem('plinq.number', this.number)
      ls.setItem('plinq.suffix', this.suffix)
      ls.setItem('plinq.type', this.type)
      ls.setItem('plinq.quote', this.quote)
    }
  }
}
</script>

<style scoped lang="scss">
.postcode-check {
  display: flex;
  align-items: center;
}

.postcode-check__icon {
  width: 60px;
}

.postcode-check__content {
  flex: 1;
  h2 {
    margin: 0;
    margin-bottom: 5px;
  }
  div {
    font-weight: 300;
  }
}

.postcode-check__form {
  display: flex;

  .form-group {
    padding-left: 10px;
  }
}

.postcode-check__postcode input {
  width: 150px;
}
.postcode-check__number input,
.postcode-check__suffix input {
  width: 80px;
}

@include mobile {
  .postcode-check {
    flex-direction: column;
  }

  .postcode-check__form {
    flex-direction: column;

    margin-top: 20px;
    margin-left: -10px;
    width: 100%;

    .form-group {
      padding-left: 0;
    }
  }

  .postcode-check__postcode input {
    width: 95%;
  }

  .postcode-check__number input,
  .postcode-check__suffix input {
    width: 95%;
  }
}
</style>
